import { AxiosRequestConfig } from 'axios';

export function getAxiosRequestConfig(): AxiosRequestConfig {
  return {
    headers: { 'X-CSRF-Token': localStorage.getItem('csrfToken') ?? '' },
    withCredentials: true,
  };
}
